// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","title":"App_title__wJw7v","strictModeToggle":"App_strictModeToggle__LhP-x"};